import { Button, ButtonProps } from "@mui/material";
import React from "react";
import { BsPlus } from "react-icons/bs";
// import { Container } from './styles';

const GradientButton: React.FC<ButtonProps> = (props) => {
  return (
    <Button
      {...props}
      style={{
        background: "linear-gradient(45deg, #4A76FB , #06D986)",
        marginLeft: 8,
        height: 36,
        borderRadius: 4,
        minWidth: 130,
        textTransform: "none",
        boxShadow: "none",
      }}
      variant="contained"
      startIcon={<BsPlus />}
    >
      Novo lead
    </Button>
  );
};

export default GradientButton;
